
import { firestore } from '../../../firebase'

import { apiSyncReducer, } from 'scorpion-core';



export function listarAllPefis(sincronizador) {

    apiSyncReducer(getColPerfil())(sincronizador)
}

function getColPerfil() {
    return firestore().collection("PerfilUser")
}




// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/api.js